const activeClass = 'active';

const updateSingleLabel = (currentTarget) => {
    if (currentTarget.val() === '') {
        currentTarget.siblings('label').removeClass(activeClass);
    } else {
        currentTarget.siblings('label').addClass(activeClass);
    }
};

// Control label behaviour as a placeholder
const updateInputLabels = (formControl) => {
    setTimeout(() => {
        if (formControl) {
            formControl.each((index, input) => {
                const currentTarget = $(input);
                const currentTargetID = currentTarget.attr('id');
                currentTarget.attr('placeholder', '');

                if (currentTarget.is(':-webkit-autofill') || currentTarget.val() !== '' || (currentTarget.val() !== '' && currentTargetID === 'login-form-email') || (currentTarget.val() !== '' && currentTargetID === 'email-guest') || (currentTarget.val() !== '' && currentTargetID === 'email') || (currentTarget.val() !== '' && currentTargetID === 'login-form-password') || (currentTarget.val() !== '' && currentTargetID === 'password') || (currentTarget.val() !== '' && currentTargetID === 'phoneNumber') || (currentTarget.val() !== '' && currentTargetID === 'billingZipCode') || currentTargetID === 'birthday' || (currentTargetID.indexOf('password') !== -1 && currentTarget.val() !== '')) {
                    currentTarget.prev('label').addClass(activeClass);
                } else {
                    currentTarget.prev('label').removeClass(activeClass);
                }
            });
        }
    }, 1000);
};

const inputFocus = () => {
    const docBody = $(document.body);
    const formControl = docBody.find('label + .form-control');

    docBody.on('focus focusin', 'label + .form-control', (e) => {
        const currentTarget = $(e.currentTarget);
        currentTarget.siblings('label').addClass(activeClass);
    });

    docBody.on('click', '.form-control-label', (e) => {
        const currentTarget = $(e.currentTarget);
        currentTarget.addClass(activeClass);
        currentTarget.siblings('input').trigger('focus');
    });

    docBody.on('blur input', 'label + .form-control', (e) => {
        updateSingleLabel($(e.currentTarget));
    });

    updateInputLabels(formControl);

    document.querySelector('input').addEventListener('animationstart', updateInputLabels(formControl), false);
};

const updateSelectLabels = (labelSelect) => {
    labelSelect.each((index, select) => {
        const currentTarget = $(select);

        if (!currentTarget.hasClass('options-select')) {
            currentTarget.prev().addClass('d-none');
        }

        if (currentTarget.val() === '' || currentTarget.val() === null) {
            currentTarget.addClass('empty');
        } else {
            currentTarget.removeClass('empty');
        }
    });
};

// Hide select labels (avoid ISML override)
const selectLabel = () => {
    const docBody = $(document.body);
    const labelSelect = docBody.find('label + select, .form-group > select');

    if (labelSelect.length) {
        updateSelectLabels(labelSelect);
        labelSelect.parent().addClass('form-group-select');

        labelSelect.on('change blur', (e) => {
            const currentTarget = $(e.currentTarget);
            if (currentTarget.val() !== '') {
                currentTarget.removeClass('empty');
            } else {
                currentTarget.addClass('empty');
            }

            if (currentTarget.attr('name') === 'shipmentSelector') {
                const formControl = docBody.find('label + .form-control');
                updateSelectLabels(labelSelect);
                updateInputLabels(formControl);
            }
        });
    }
};

const inputPassword = () => {
    const docBody = $(document.body);
    const inputPass = $('input[type="password"]');

    if (inputPass.length) {
        inputPass.each((index, input) => {
            const currentTarget = $(input);
			const showLabel = currentTarget.data('showPassword') || 'Show password';
    		const eyeIcon = `<button type="button" class="form-icon icon-eye-line no-btn" aria-label="${showLabel}" aria-pressed="false"></button>`;
            currentTarget.parent().append(eyeIcon);
        });
    }

    docBody.on('click touch', '.icon-eye-line', (e) => {
        e.stopImmediatePropagation();
        const thisTarget = $(e.currentTarget);
        const input = thisTarget.parent().find('input');
        if (input.attr('type') === 'password') {
            input.attr('type', 'text');
            thisTarget.addClass('icon-eye-v2-line');
			thisTarget.attr('aria-label', input.data('hidePassword') || 'Hide password');
    		thisTarget.attr('aria-pressed', 'true');
        } else {
            input.attr('type', 'password');
            thisTarget.removeClass('icon-eye-v2-line');
			thisTarget.attr('aria-label', input.data('showPassword') || 'Show password');
    		thisTarget.attr('aria-pressed', 'false');
        }
    });
};

const clearInvalidFeedBack = () => {
    $('button[type=submit]').on('click', (e) => {
        const myForm = $(e.target).closest('form');
        if (myForm.length) {
            $(myForm).find('.is-invalid').removeClass('is-invalid');
            $(myForm).find('.invalid-feedback').empty();
        }
    });
};

module.exports = {
    inputFocus,
    selectLabel,
    inputPassword,
    updateInputLabels,
    clearInvalidFeedBack,
};
